export const AVAILABLE_RESCHEDULE_DATE_KEY_FORMAT = 'yyyy-MM-dd';
